/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {ResponsiveConf} from '@gongxigames/framework/core/fragments/display/responsive';
import {ComputedSignal, Store} from '@gongxigames/framework/core/fragments/store/Store';
import {slotStore} from '@gongxigames/framework/slotV2/globals';

export function getPopupResponsiveConfig() {
    let popupBgConfig: ComputedSignal<ResponsiveConf>;
    let autoplayBtnConfig: ComputedSignal<ResponsiveConf>;
    let separator1Config: ComputedSignal<ResponsiveConf>;
    let separator2Config: ComputedSignal<ResponsiveConf>;
    let roundsSelector: ComputedSignal<ResponsiveConf>;
    let optionsSelector: ComputedSignal<ResponsiveConf>;

    {
        popupBgConfig = Store.computed(() => slotStore.stage_isPortrait.value ? {
            box: {width: '936px', height: '1460px'},
            translate: {x: '-50%', y: '-50%'}
        } : {
            box: {width: '1460px', height: '1000px'},
            translate: {x: '-50%', y: '-50%'}
        });
    };

    {
        autoplayBtnConfig = Store.computed(() => slotStore.stage_isPortrait.value ? {
            box: {x: '50%', y: '100%'},
            translate: {x: '0px', y: '-76px'},
        } : {
            box: {x: '50%', y: '100%'},
            translate: {x: '0px', y: '-20px'},
        });
    };

    {
        separator1Config = Store.computed(() => slotStore.stage_isPortrait.value ? {
            box: {x: '50%', y: '50%'},
            translate: {y: '-50px'},
        } : {
            box: {x: '50%', y: '50%'},
            translate: {y: '26px'},
        });
    };

    {
        separator2Config = Store.computed(() => slotStore.stage_isPortrait.value ? {
            box: {x: '50%', y: '100%'},
            translate: {y: '-200px'},
        } : {
            box: {x: '50%', y: '100%'},
            translate: {y: '-110px'},
        });
    };

    {
        roundsSelector = Store.computed(() => slotStore.stage_isPortrait.value ? {
            box: {x: '50%', y: '50%'},
            translate: {x: '0', y: '14px'},
        } : {
            box: {x: '50%', y: '50%'},
            translate: {x: '0', y: '70px'},
        });
    };

    {
        optionsSelector = Store.computed(() => slotStore.stage_isPortrait.value ? {
            box: {x: '0', y: '0'},
            translate: {x: '60px', y: '34px'},
        } : {
            box: {x: '0', y: '0'},
            translate: {x: '60px', y: '0'},
        });
    };

    return {
        popupBgConfig,
        autoplayBtnConfig,
        separator1Config,
        separator2Config,
        roundsSelector,
        optionsSelector,
    }
}
